var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.569,
    height: 30.45,
    viewBox: "0 0 30.569 30.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart-large-2-svgrepo-com",
    transform: "translate(0.95 0.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M2,3l.423.142c2.107.709,3.16,1.063,3.762,1.907s.6,1.965.6,4.206v4.216c0,4.557,0,6.835,1.4,8.251s3.659,1.416,8.173,1.416H29.129",
    transform: "translate(-2 -3)",
    fill: "none",
    stroke: "#003e93",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M8.417,18A2.417,2.417,0,1,1,6,20.417,2.417,2.417,0,0,1,8.417,18Z",
    transform: "translate(0.376 6.167)",
    fill: "none",
    stroke: "#003e93",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    d: "M17.417,18A2.417,2.417,0,1,1,15,20.417,2.417,2.417,0,0,1,17.417,18Z",
    transform: "translate(5.685 6.167)",
    fill: "none",
    stroke: "#003e93",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M5,6H23.448c3.311,0,4.966,0,5.683,1.086s.064,2.608-1.24,5.651L27.2,14.348c-.609,1.421-.913,2.131-1.519,2.53s-1.378.4-2.924.4H5",
    transform: "translate(-0.426 -1.167)",
    fill: "none",
    stroke: "#003e93",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.60f2dbc6f9876dc801673b3beae87fc3.svg";
export { ForwardRef as ReactComponent };